import { api } from '../core';

interface UpdateChronologyEntryCommentResponse {
  success: boolean;
}

interface UpdateChronologyEntryCommentProps {
  abortController?: AbortController;
  entryId: string;
  comment: string;
}

const chronologyEntryCommentUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntryComment: builder.query<
      UpdateChronologyEntryCommentResponse,
      UpdateChronologyEntryCommentProps
    >({
      query: ({ abortController = new AbortController(), entryId, comment }: UpdateChronologyEntryCommentProps) => ({
        url: 'chronology/entry/comment/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          comment
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntryComment in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntryCommentQuery } = chronologyEntryCommentUpdateApi;
